module.exports = "/_next/static/festival-rw.aabc087aa959cf0a76bbb31000b2060d.css";